import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Common/Button';

interface IGameMenuProps {
    onShowMenu(): void;
}

export const GameMenu: React.FunctionComponent<IGameMenuProps> = props => {
    const { t } = useTranslation();
    return (
        <div>
            <h1>{t('game.gameMenu.title')}</h1>
            <form method="dialog">
                <Button type="submit">{t('continue')}</Button>
            </form>
            <Button onClick={props.onShowMenu}>{t('backToMenu')}</Button>
        </div>
    );
};
